/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentMethodBody
 */
export interface UpdatePaymentMethodBody {
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentMethodBody
     */
    expMonth: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentMethodBody
     */
    expYear: number;
}

/**
 * Check if a given object implements the UpdatePaymentMethodBody interface.
 */
export function instanceOfUpdatePaymentMethodBody(value: object): value is UpdatePaymentMethodBody {
    if (!('expMonth' in value) || value['expMonth'] === undefined) return false;
    if (!('expYear' in value) || value['expYear'] === undefined) return false;
    return true;
}

export function UpdatePaymentMethodBodyFromJSON(json: any): UpdatePaymentMethodBody {
    return UpdatePaymentMethodBodyFromJSONTyped(json, false);
}

export function UpdatePaymentMethodBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentMethodBody {
    if (json == null) {
        return json;
    }
    return {
        
        'expMonth': json['expMonth'],
        'expYear': json['expYear'],
    };
}

export function UpdatePaymentMethodBodyToJSON(json: any): UpdatePaymentMethodBody {
    return UpdatePaymentMethodBodyToJSONTyped(json, false);
}

export function UpdatePaymentMethodBodyToJSONTyped(value?: UpdatePaymentMethodBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expMonth': value['expMonth'],
        'expYear': value['expYear'],
    };
}

